import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import UploadedFile from './UploadedFile-redux';

export default compose(
    withRouter
)(UploadedFile);
